import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

import arrowRightIcon from '../asset/img/listcard_arrow_right.svg';
import Typography from './common/Typography';
import { getAlertMessageFunction } from '../common/Util';

const shouldForwardProp = prop => prop !== 'isFirst' && prop !== 'detail';

const ListCardStyled = styled.div.withConfig({ shouldForwardProp })`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  border-bottom: 1px solid var(--GrayScale-400);
  background: var(--GrayScale-0);

  ${({ isFirst }) =>
    isFirst &&
    `
    border-top: 1px solid var(--GrayScale-400);
  `}
`;

const ListCard = ({ content, isFirst, onClick, detail = true, title }) => {
  return (
    <ListCardStyled isFirst={isFirst} onClick={onClick}>
      <div>{content}</div>
      {detail && <img src={arrowRightIcon} alt={`${title} 상세보기`} />}
    </ListCardStyled>
  );
};

export default ListCard;

// 공제대상아님
export const ListCardNotDeduction = ({ title, isFirst }) => {
  const { t } = useTranslation('common');
  return (
    <ListCardStyled isFirst={isFirst}>
      <div>
        <Typography variant="body2Bold">{title}</Typography>
        <Typography variant="captionMedium">{t('deduction.notTarget')}</Typography>
      </div>
    </ListCardStyled>
  );
};

// 공제항목 미설정
export const ListCardNotSetDeduction = ({ title, isFirst }) => {
  const { t } = useTranslation('common');

  const handleClick = () => {
    const alertMessage = getAlertMessageFunction();
    alertMessage(t('alertMessage.deductionMessage'));
  };

  return (
    <ListCardStyled isFirst={isFirst}>
      <div>
        <Typography variant="body2Bold">{title}</Typography>
        <Typography variant="captionMedium">{t('deduction.notSet')}</Typography>
      </div>
      <Typography variant="body2Medium" color="Primary-500" onClick={handleClick}>
        {t('deduction.set')}
      </Typography>
    </ListCardStyled>
  );
};
